import { useHistory } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { useAlertas } from '../context/AlertasContext';

export const CampanaAlerta = () => {
    const history = useHistory();
    const { totalAlertas, loading } = useAlertas();

    const navegarInicio = () => {
        history.push('/');
    };

    // Si no hay alertas, no renderizamos nada
    if (totalAlertas === 0) return null;

    return (
        <div className="flex align-items-center">
            <span className="p-overlay-badge">
                <Button icon="pi pi-bell" severity="secondary" text pt={{ icon: { style: { fontSize: '1.45rem' } } }} onClick={navegarInicio} tooltip="Ver alertas" tooltipOptions={{ position: 'bottom' }} loading={loading} />
                <Badge value={totalAlertas} severity="danger" style={{ minWidth: '1rem', height: '1rem', lineHeight: '1rem', fontSize: '0.65rem', transform: 'translate(20%, 0%)', pointerEvents: 'none' }} />
            </span>
        </div>
    );
};